import find from 'lodash/find';
import forEach from 'lodash/forEach';
import defaults from 'lodash/defaults';
import isEmpty from 'lodash/isEmpty';
import reject from 'lodash/reject';
import findIndex from 'lodash/findIndex';
import { CI_DRUGLIKENESS_COMPONENTS } from './CI-DruglikenessConstants';
import DruglikenessComponent from './DruglikenessComponent';

const { TABLE_LABELS, GRAPH_LABELS } = DruglikenessComponent;

class CustomDruglikenessComponent extends DruglikenessComponent {
  // custom labels
  static TABLE_LABELS = defaults(
    {
      'lipinskiComponent.logP': 'cLogP',
    },
    TABLE_LABELS
  );

  static GRAPH_LABELS = defaults(
    {
      'lipinskiComponent.logP': 'cLogP',
    },
    GRAPH_LABELS
  );

  static TABLES = CI_DRUGLIKENESS_COMPONENTS;

  static _postProcessRows = (rows) => {
    const processedRows = reject(rows, ({ id }) => id === 'lipinskiComponent.molecularWeight');

    // move SNR to the last position
    const snrIdx = findIndex(processedRows, (item) => item.id === 'otherComponents.SNR');
    if (snrIdx > -1) {
      processedRows.push(processedRows.splice(snrIdx, 1)[0]);
    }
    return processedRows;
  };

  getTableData() {
    const dataset = this.getDataset();
    const tableData = super.getTableData();
    let rows = !isEmpty(tableData) ? tableData[0].children : []; // use reaxys tables

    // push other values
    forEach(dataset, ({ id, value }) => {
      const yes = find(rows, { id });
      if (!yes) {
        rows.push({ id, value, title: this.getTableLabel(id) });
      }
    });

    // CI specific sorting logic
    rows = CustomDruglikenessComponent._postProcessRows(rows);

    return [{ title: '', children: rows }];
  }
}

export default CustomDruglikenessComponent;
